<template>
  <li class="mm-select-dropdown-menu-item-group">
    <div
      v-if="label"
      class="mm-select-dropdown-menu-item-group-title">
      {{ label }}
    </div>
    <ul class="mm-select-dropdown-menu-item-group-list">
      <slot></slot>
    </ul>
  </li>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
    },
  },
}
</script>
